
import React, {Component} from 'react'
import { connect } from 'react-redux'
import SettingsSnooze from './components/Settings/SettingsSnooze'
import SettingsStep from './components/Settings/SettingsStep'

import {
  setTitle
} from 'common/redux/root'

import {
  saveSnoozeCategory, updateSnoozeCategory, removeSnoozeCategory
} from 'manager/redux/settings'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class SettingsSnoozeContainer extends Component {

  constructor(props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.handleRemove = this.handleRemove.bind(this)
  }

  componentWillMount() {
    this.props.dispatch(setTitle("Snooze Notifications"))
  }

  handleSubmit(cb) {
    this.props.dispatch(saveSnoozeCategory(this.props.settings.snooze_category))
      .then(() => cb())
  }

  handleSelect(key, enabled) {
    this.props.dispatch(updateSnoozeCategory(key))
  }

  handleRemove(cb) {
    this.props.dispatch(removeSnoozeCategory())
      .then(() => cb())
  }

  render() {
    const shouldDisableSubmit = !this.props.settings.snooze_category

    return <SettingsStep shouldDisableSubmit={shouldDisableSubmit} onSubmit={this.handleSubmit} {...this.props}>
      <SettingsSnooze onRemove={this.handleRemove} onSelect={this.handleSelect} {...this.props} />
    </SettingsStep>
  }

}

export default connect((state) => ({ settings: state.settings }), mapDispatchToProps)(SettingsSnoozeContainer)
